var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a ng-href=\"{{href}}\" ng-click=\"showLoader()\">Pay</a>";
var id1="public-booking/paypal-buttons/paypal_express_button.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/paypal-buttons/paypal_express_button.html
// module id = 1235
// module chunks = 0